import axios, { AxiosRequestConfig, isAxiosError } from 'axios';

import { getApiBaseUrl } from './apiBaseUrl';

const axiosServices = axios.create({ baseURL: getApiBaseUrl() });

function rejectAsError(reason: unknown): Promise<never> {
  if (reason instanceof Error) {
    return Promise.reject(reason);
  }
  return Promise.reject(new Error(typeof reason === 'string' ? reason : 'Request failed', { cause: reason }));
}

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error: unknown) => rejectAsError(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    const status = isAxiosError(error) ? error.response?.status : undefined;
    if (status === 401 && !window.location.href.includes('/login')) {
      redirectWithBasePath('/login');
    }
    // Preserve AxiosError when possible so callers and `getApiErrorMessage` can read status + body.
    return rejectAsError(error);
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};

export function redirectWithBasePath(path: string) {
  const basePath = import.meta.env.VITE_APP_BASE_NAME ?? ''; // adjust for Vite, CRA, etc.
  window.location.pathname = `${basePath.replace(/\/$/, '')}${path}`;
}
